import * as URI from "urijs";
import { ApiIO } from "../common/cprofit-api";
import { getSgConnectTokenFromBus } from "./auth/sgConnectAuth";
import { CProfitWidgetConfiguration } from "./cprofitWidgetConfiguration";
import { logPerformance } from "./logger/performance";

export const cprScApiRequest = (apiIo: ApiIO) => (
  queryOrBody: object
): Promise<Response> => {
  return getSgConnectTokenFromBus(apiIo.configuration.bus).then(token => {
    const cprConfig = new CProfitWidgetConfiguration(apiIo.configuration);
    let fullUri = getFullUri(apiIo.baseUri, cprConfig, apiIo.isPrivate);
    const basicHeaders = {
      ...apiIo.headers,
      Accept: "application/json",
      Authorization: token as string,
      "Content-Type": "application/json",
      "X-SGR-CorrelationID": apiIo.correlationId,
    };
    const requestInit: RequestInit = {
      credentials: "include",
      headers: basicHeaders,
    };

    if (apiIo.method === "GET") {
      fullUri = fullUri.query(URI.buildQuery(queryOrBody));
      fullUri.setQuery("timeout", "180");
      if (fullUri.toString().length > 1900) {
        apiIo.method = "POST";
        requestInit.body = JSON.stringify(queryOrBody);
        fullUri = URI(apiIo.baseUri).absoluteTo(
          apiIo.isPrivate ? cprConfig.soaPrivateUrl() : cprConfig.soaUrl()
        );
      }
    } else {
      requestInit.body = JSON.stringify(queryOrBody);
    }

    requestInit.method = apiIo.method;
    return logPerformance(apiIo, fullUri.valueOf(), requestInit);
  });
};

function getFullUri(
  baseUri: string,
  cprConfig: CProfitWidgetConfiguration,
  isPrivate: boolean
) {
  return URI(baseUri).absoluteTo(
    isPrivate ? cprConfig.soaPrivateUrl() : cprConfig.soaUrl()
  );
}
